import React, {useState, useEffect} from "react";
import {ReactComponent as PlusIcon} from "../../assets/icons/plus.svg";
import {ReactComponent as PdfIcon} from "../../assets/icons/pdf.svg";
import {ButtonWithIcon} from "../../styles/Butttons";
import HeadView from "../../containers/HeadView";
import AddAdminModal from "./components/AddModal";
import Table from "../../components/table/Tables";
import AppLoader, {LoadComponet} from "../../components/loaders/Loader";
import AdminsData from "./components/Data";
import ShowAdminModal from "./components/ShowModal";
import EditAdminModal from "./components/EditModal";
import DeleteModal from "../../components/modals/DeleteModal";
import {ListAdminService, UpdateUserService} from "../../services/UserServices";

export default function AdminsView({theme}) {
   const [newAdmind, setNewAdmin] = useState(false);
   const [newAdmindSuccess, setNewAdminSuccess] = useState(false);
   const [showAdmin, setShowAdmin] = useState({isOpen: false, data: {}});
   const [editAdmin, setEditAdmin] = useState({isOpen: false, data: {}, showSuccess: false});
   const [deleteAdmin, setDeleteAdmin] = useState({isOpen: false, id: "", url: ""});
   const [isLoading, setIsLoading] = useState({data: true, view: false});
   const [data, setData] = useState([]);
   const [removeSuccess, setRemoveSuccess] = useState(false);

   useEffect(() => {
      getData();
   }, []);

   const getData = () => {
      ListAdminService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newUsers = data.map((item) => {
               return {...item, name: item.userName + " " + item.userLastName};
            });
            setData(newUsers);
            setIsLoading({...isLoading, data: false});
         })
         .then(() => {
            setIsLoading({...isLoading, data: false});
         })
         .catch((e) => {
            setIsLoading({...isLoading, data: false});
            console.log(e);
         });
   };

   const saveData = (user) => {
      // recibe los datos del nuevo usario ya actulizado en base de datos
      if (!user) return false;
      let newId = data.length;
      const newAdminList = [...data, {...user, id: newId + 1}];

      setData(newAdminList);
   };

   const updateAdmin = (user) => {
      // recibe los datos del ya actulizado en base de datos
      if (!user) return false;
      let newAdminList = data.map((item) => {
         if (item.id === user.id) return {...user};
         return item;
      });
      setData(newAdminList);
      setEditAdmin({...editAdmin, showSuccess: true});
   };

   const removeId = () => {
      let toSend = data.find((item) => item.idUser === deleteAdmin.id);
      let newAdminList = data.filter((item) => item.idUser !== deleteAdmin.id);
      toSend = {...toSend, idRol: 2};

      UpdateUserService(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status} = resp;
            if (status === "error") throw new Error();
            setData(newAdminList);
         })
         .then(() => {
            setRemoveSuccess(true);
         })
         .then(() => {
            setDeleteAdmin({isOpen: false, id: "", url: ""});
         })
         .catch((e) => {
            setRemoveSuccess(true);
            setDeleteAdmin({isOpen: false, id: "", url: ""});
            console.log(e);
         });
   };

   return (
      <>
         <HeadView>
            <>
               <ButtonWithIcon
                  text="Nuevo Administrador"
                  Icon={PlusIcon}
                  action={() => {
                     setNewAdmin(true);
                  }}
               />
            </>
            <></>
         </HeadView>
         {isLoading.data ? (
            <LoadComponet isVisible={true} theme={theme} />
         ) : (
            <Table
               data={data}
               columns={Columns}
               theme={theme}
               showModal={(user) => {
                  setShowAdmin({isOpen: true, data: data.find((item) => item.idUser === user.idUser), showSuccess: false});
               }}
               editModal={(user) => {
                  setEditAdmin({isOpen: true, data: data.find((item) => item.idUser === user.idUser)});
               }}
               deleteModal={(adminUser) =>
                  setDeleteAdmin({isOpen: true, id: adminUser.idUser, url: "http://freeticket.trebolbit.com/api/city/list"})
               }
            />
         )}
         <AddAdminModal
            isOpen={newAdmind}
            close={() => {
               setNewAdminSuccess(false);
               setNewAdmin(false);
            }}
            save={saveData}
            showSuccess={newAdmindSuccess}
            theme={theme}
            reloadSucces={getData}
         />
         <ShowAdminModal
            isOpen={showAdmin.isOpen}
            close={() => {
               setShowAdmin({isOpen: false, data: []});
            }}
            data={showAdmin.data}
            theme={theme}
         />
         <EditAdminModal
            isOpen={editAdmin.isOpen}
            close={() => {
               setEditAdmin({isOpen: false, data: [], showSuccess: false});
            }}
            data={editAdmin.data}
            theme={theme}
            save={updateAdmin}
            showSuccess={editAdmin.showSuccess}
         />
         <DeleteModal
            isOpen={deleteAdmin.isOpen}
            id={deleteAdmin.id}
            url={deleteAdmin.url}
            confirm={removeId}
            close={() => {
               setDeleteAdmin({isOpen: false, id: "", url: ""});
            }}
            showSuccess={removeSuccess}
         />
         <AppLoader isVisible={isLoading.data} />
      </>
   );
}

const Columns = [
   {
      title: "#",
      accessor: "idUser",
      class: "idCol normal",
   },
   {
      title: "Nombre",
      accessor: "name",
      action: "show",
   },
   {
      title: "email",
      accessor: "email",
   },
   /*    {
      title: "teléfono",
      accessor: "phone",
   }, */
   {
      title: "ciudad",
      accessor: "city",
   },
   /*   {
      title: "Contraseña",
      accessor: "password",
   }, */
   /*
    */
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];

/* <ButtonWithIcon
            text="Nuevo Administrador"
            Icon={PlusIcon}
            action={() => {
               alert("sad");
            }}
         />
         <ButtonWithIcon
            text="Agregar otro"
            classname="text"
            Icon={PlusIcon}
            action={() => {
               alert("sad");
            }}
         />
         <ButtonWithIcon
            text=""
            Icon={CancelIcon}
            disabled={true}
            action={() => {
               alert("sad");
            }}
         />
         <ButtonWithIcon
            text="Descargar"
            Icon={PdfIcon}
            right={true}
            disabled={true}
            action={() => {
               alert("sad");
            }}
         /> */
